import {Component, inject, signal} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {Fluid} from 'primeng/fluid';
import {MessageModule} from 'primeng/message';
import {ProviderDataControllerService, UpdateProviderDataRequest} from '@frontend/shared';
import {toSignal} from '@angular/core/rxjs-interop';
import {ProviderDataFormComponent, ProviderDataFormData} from './form/provider-data-form.component';
import {finalize} from 'rxjs';
import {ToastService} from '@frontend/toast';

@Component({
  selector: 'app-provider-data',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    Fluid,
    MessageModule,
    ProviderDataFormComponent,
  ],
  templateUrl: './provider-data.component.html',
})
export class ProviderDataComponent {
  private readonly providerDataService = inject(ProviderDataControllerService);
  private readonly toast = inject(ToastService);

  saving = signal(false);
  providerData = toSignal(this.providerDataService.getCurrentProviderData(), {
    initialValue: null,
  });

  protected onSubmit($event: ProviderDataFormData) {
    const request = {
      street: $event.street,
      houseNumber: $event.houseNumber,
      zipCode: $event.zipCode,
      city: $event.city,
      countryCode: $event.countryCode,
      tenderContactEmail: $event.tenderContactEmail,
      salesTaxNumber: $event.salesTaxNumber,
    } as UpdateProviderDataRequest;
    this.saving.set(true);
    this.providerDataService
      .updateCurrentProviderData({updateProviderDataRequest: request})
      .pipe(
        finalize(() => {
          this.saving.set(false);
        }),
      )
      .subscribe({
        next: () => {
          this.toast.showSuccess(
            'providerData.success.update.title',
            'providerData.success.update.detail',
          );
        },
        error: () => {
          this.toast.showError('providerData.errors.update.title', 'error.generic.detail');
        },
      });
  }
}
